import { useGameStore } from '../store/game-store.ts';

/** Short-lived server notifications (e.g. a patrol stopped because its route became unreachable). */
export function Toaster() {
  const { toasts, dismissToast } = useGameStore();
  if (toasts.length === 0) return null;
  return (
    <div className="fixed top-[calc(3.5rem+var(--sat))] left-0 right-0 z-50 flex flex-col items-center gap-2 px-4 pointer-events-none" aria-live="polite">
      {toasts.map(t => (
        <div
          key={t.id}
          role={t.tone === 'error' ? 'alert' : 'status'}
          className="pointer-events-auto max-w-md w-full rounded-lg px-4 py-2 text-sm flex items-center justify-between gap-3 shadow-lg"
          style={{
            background: t.tone === 'error' ? 'rgba(127,29,29,0.95)' : 'rgba(15,23,42,0.95)',
            border: `1px solid ${t.tone === 'error' ? 'rgba(248,113,113,0.5)' : 'rgba(0,229,255,0.4)'}`,
            color: t.tone === 'error' ? '#fecaca' : '#e2e8f0',
          }}
        >
          <span>{t.text}</span>
          <button type="button" onClick={() => dismissToast(t.id)} aria-label="Értesítés bezárása" className="text-lg leading-none" style={{ minWidth: 44, minHeight: 44 }}>×</button>
        </div>
      ))}
    </div>
  );
}
